/**
 * @format
 */

import { useEffect, useState, useCallback } from 'react';
import { SalesSummary, DashboardQueryParams } from '../types/dashboard.types';
import { dashboardService } from '../services/dashboardService';

interface UseSalesSummaryOptions {
  params?: DashboardQueryParams;
}

export const useSalesSummary = ({ params }: UseSalesSummaryOptions = {}) => {
  const [data, setData] = useState<SalesSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await dashboardService.getSalesSummary(params);
      setData(result);
    } catch (err: any) {
      console.error('Error in useSalesSummary:', err);
      setError(
        err.message || 'Error fetching sales summary data'
      );
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
